import Vue from 'vue';
import CartProductQuantity from '@/modules/product/components/ProductQuantity.vue';
export default Vue.extend({
    components: {
        CartProductQuantity,
    },
    props: {
        item: {
            type: Object,
        },
    },
    data() {
        return { isMobile: false };
    },
    mounted() {
        // Keep this breakpoint consistent with your CSS (e.g. 768px)
        const mq = window.matchMedia('(max-width: 767.98px)');
        const update = () => {
            this.isMobile = mq.matches;
        };
        update(); // set initial value
        // add listener (new + old browser support)
        if (mq.addEventListener)
            mq.addEventListener('change', update);
        else
            mq.addListener(update);
        this.$once('hook:beforeDestroy', () => {
            if (mq.removeEventListener)
                mq.removeEventListener('change', update);
            else
                mq.removeListener(update);
        });
    },
    computed: {
        discountPercent() {
            const original = Number(this.item?.old_price);
            const discounted = Number(this.item?.price);
            if (!original || !discounted || discounted >= original)
                return 0;
            return Math.round(((original - discounted) / original) * 100);
        },
    },
});
